import Icon from "core/assets/icons";
import CFollowComunity from "core/components/CFollowCommunity";
import CLikeComunity from "core/components/CLikeCommunity";
import CShareComunity from "core/components/CShareCommunity";
import { Button } from "core/components/form-controls";
import Image from "core/components/Image";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { _t } from "core/language";
import { RouterName } from "core/router";
import { shortenNumber } from "core/utils/helper";
import React, { useEffect, useState } from "react";

interface Props {
  stateFollow?: boolean;
  isFixed?: boolean;
  handleFollow?: () => void;
  countFollower?: number;
  countShare?: number;
  countLike?: number;
  name?: string;
  image?: string;
  isCurrentUser?: boolean;
  userInfo?: any;
  loading?: boolean;
}

const InfoPersonal: React.FC<Props> = ({ 
  stateFollow, 
  handleFollow, 
  isFixed, 
  countFollower, 
  countShare, 
  countLike, 
  name,
  image,
  isCurrentUser,
  userInfo,
  loading,  
}) => {
  const navigate = useCustomNavigate();
  const [fixedState, setFixedState] = useState(isFixed);
  const [follow, setStateFollow] = useState(stateFollow);

  useEffect(() => {
    setFixedState(isFixed);
  }, [isFixed]);

  useEffect(() => {
    setStateFollow(stateFollow);
  }, [stateFollow]);

  const handleToPageMenu = () => {
    navigate(RouterName.CHANGE_DISPLAY_NAME)
  };

  const _handleFollow = () => {
    setStateFollow(!stateFollow)
    handleFollow?.()
  };

  return (
    <div className="header-channels">

      <div className={`
        info-personal-channel 
        pb-[16px] 
        bg-[#ffffff] 
        pt-[20px] 
        px-[16px]
        ${fixedState ? ' !pb-[0px] fade-out' : 'fixed top-[43px] w-full z-[100] fade-in '}
        `}
      >
        <div className={`text-center mb-[34px] ${fixedState ? ' !mb-[0px]' : ''}`}>
          <img src={image || Icon.AvatarBigDefault} className="inline-block object-cover rounded-full w-[80px] h-[80px]" alt="AvatarBigDefault" />
          <div className="flex align-items-center justify-center mt-[14px]">
            <p className="text-[13px] font-bold mr-[3px]">{name}</p>
            {isCurrentUser ? <img src={Icon.EditUser} alt="AvatarBigDefault" onClick={handleToPageMenu} /> : '' }
          </div>
        </div>
        {loading && !isCurrentUser && userInfo?.id ? <div className={`h-[50px] bg-gray-300 rounded-full w-full animate-pulse`}></div> :
        <Button
          classBtn={`mt-4 
                  [box-shadow:none!important] 
                  font-medium 
                  px-4 
                  text-left w-full h-[50px] 
                  ${follow ? ' !text-[#111111] !bg-[#eeeeee]' : ''}
                  ${fixedState ? ' !mt-[0px]' : ' '}
                  ${isCurrentUser ? ' hidden' : ''}
                  ${userInfo?.id ? '' : ' hidden'}
                  `
          }
          iconRight={follow ? Icon.Follwed : Icon.AddFollow}
          iconClassName="mr-1"
          rounded
          primary
          size="sm"
          label={_t(follow ? "comunity.follwed" : "comunity.follow")}
          onClickBtn={_handleFollow}
        /> }
        <div className="statistic-info flex justify-between px-[20px] mt-[26px]" style={{ display: fixedState ? 'none' : 'flex' }}>
          <div className="flex justify-center items-center flex-col">
            <p className="text-[20px] font-bold">{shortenNumber(countFollower || 0)}</p>
            <p className="text-[9px] text-[#777777]">{_t("comunity.follower")}</p>
          </div>
          <div className="flex justify-center items-center flex-col">
            <p className="text-[20px] font-bold">{shortenNumber(countShare || 0)}</p>
            <p className="text-[9px] text-[#777777]">{_t("comunity.post_share")}</p>
          </div>
          <div className="flex justify-center items-center flex-col">
            <p className="text-[20px] font-bold">{shortenNumber(countLike || 0)}</p>
            <p className="text-[9px] text-[#777777]">{_t("comunity.like_share")}</p>
          </div>
        </div>
      </div>
      <div>
        <div className={`
          bg-[#ffffff] 
          pt-[20px] 
          px-[16px] 
          flex items-center 
          w-full 
          justify-between 
          m-h-[80px] 
          transition-all 
          duration-500 
          ${fixedState ? ' fixed left-0 top-[43px] z-[100] flex fade-in ' : ' fade-out '}`
          }>
          <div className="border-b-[1px] border-[#eeeeee] w-full  flex items-center w-full justify-between pb-[20px]">
            <div className="flex items-center">
              <div className="mr-[6px]">
                <Image src={image || Icon.AvatarBigDefault} alt={'name'} className="object-cover rounded-full w-[40px] h-[40px]" />
              </div>
              <div className="flex flex-col">
                <div className="flex items-center mb-[10px]">
                  <h3 className="text-[13px] font-medium text-[#111111] mr-[5px]">{name}</h3>
                  {isCurrentUser ? <img src={Icon.EditUser} alt="AvatarBigDefault" onClick={handleToPageMenu} /> : ''}
                </div>
                <div className="flex pointer-events-none">
                  <CFollowComunity className="mr-[15px]" id={1} countFollow={countFollower} />
                  <CShareComunity dataCount={countShare} className="mr-[15px]" id={1} />
                  <CLikeComunity type={"post"} id={1} countLike={countLike} />
                </div>
              </div>
            </div>
            <div>
              <Button
                classBtn={`mt-0
                    [box-shadow:none!important] 
                    font-medium 
                    px-[23px] 
                    text-left w-full h-[40px] 
                    ${follow ? ' !text-[#111111] !bg-[#eeeeee]' : ''}
                    ${isCurrentUser ? ' hidden' : ''}
                    ${userInfo?.id ? '' : ' hidden'}
                    `
                }
                iconRight={follow ? Icon.Follwed : Icon.AddFollowSmall}
                iconClassName="mr-1"
                rounded
                primary
                size="sm"
                label={"Theo dõi"}
                onClickBtn={_handleFollow}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPersonal;
